import { ExtendedBitmapText, ExtendedContainer, ExtendedSprite, ExtendedText, SkySpine, delay, translation, soundService, gsap } from "@aceroll/core";

import { currency } from "@aceroll/core/core/services";

const SOUNDS = {
    SHOW: "total_win_popup_show",
    HIDE: "total_win_popup_hide"
}

const ANIMATIONS = {
    SHOW: "close",
    IDLE: "idle",
    HIDE: "open"
};

const BITMAP_FONT = {
    ALIAS: 'font_3',
    ALIGN: 'center',
};

const TEXTS_CONFIG = {
    CLICK: {
        ID: "click_to_continue_uc",
        STYLE: "totalWinClickableText",
    },
    FREE_SPINS: {
        ID: "num_free_spins_played",
        STYLE: "totalWinFreeSpinsText",
    }
};

export default class TotalWinPopup extends ExtendedContainer {
    constructor() {
        super('total-win-popup')

        this._spine = new SkySpine('spine-total_win_popup');
        this._spine.visible = false;
        this.#createWinLabels();
        this.#createTextLabels();
        this.visible = false;
        this._isHiding = false;
    }

    #createWinLabels() {
        this._totalWinLabelContainer = this.addChild(new ExtendedContainer('TotalWinLabelContainer'));
        this._totalWinLabelSrite = this._totalWinLabelContainer.addChild(ExtendedSprite.fromSpriteSheet('common-total_win_label'));
        this._winAmountLabel = this._totalWinLabelContainer.addChild(new ExtendedBitmapText('', BITMAP_FONT.ALIAS, { align: BITMAP_FONT.ALIGN }));

        this._totalWinLabelContainer.alpha = 0;
        this._totalWinLabelSrite.position.set(0, -50);
        this._totalWinLabelSrite.anchor.set(0.5);
        this._winAmountLabel.position.set(0, 50);
    }

    #createTextLabels() {
        this._continueTextContainer = this.addChild(new ExtendedContainer('ContinueTextContainer'));
        this._continueText = this._continueTextContainer.addChild(new ExtendedText('', TEXTS_CONFIG.CLICK.ID, TEXTS_CONFIG.CLICK.STYLE));
        this._continueTextContainer.alpha = 0;
        this._continueText.anchor.set(0.5);
        this._continueText.position.set(0, 430);

        this._freeSpinsTextContainer = this.addChild(new ExtendedContainer('FreeSpinsTextContainer'));
        this._freeSpinsText = this._freeSpinsTextContainer.addChild(new ExtendedText('', TEXTS_CONFIG.FREE_SPINS.ID, TEXTS_CONFIG.FREE_SPINS.STYLE));
        this._freeSpinsTextContainer.alpha = 0;
        this._freeSpinsText.anchor.set(0.5);
        this._freeSpinsText.position.set(0, -480);
    }

    // Hardcoded total freespins value to 10!!!
    async show(winAmount, freeSpins = 10) {
        soundService.play(SOUNDS.SHOW);
        this._completelyShowed = false;
        this.visible = true;
        this._spine.visible = true;
        this.#setWinLabel(winAmount);
        this._freeSpinsText.text = translation.text(TEXTS_CONFIG.FREE_SPINS.ID, { 'totalFreespins': freeSpins.toString() }).toUpperCase();
        await this._spine.setImmediately(ANIMATIONS.SHOW);
        if (this._isHiding) return;
        this._spine.addAnimation(ANIMATIONS.IDLE, true);
        await this.#showWinLabel();

        if (this._isHiding) return;
        this.#startWinLabelIdleTween();
        this._completelyShowed = true;
    }

    async hide() {
        if (this._isHiding) return;

        this._isHiding = true;

        if (!this._completelyShowed) {
            this._completelyShowed = true;
            this.#stopWinLabelIdleAnimation();
            this.#setLabelsVisibility(true);
            await delay(500);
        }

        await this.#hideWinLabel();
        soundService.play(SOUNDS.HIDE);
        await this._spine.setImmediately(ANIMATIONS.HIDE);
        this._spine.reset();
        this.visible = false;
        this._spine.visible = false;

        this._isHiding = false;
    }

    #setWinLabel(winAmount) {
        const formatedValue = currency.toCurrency(Math.floor(winAmount));
        this._winAmountLabel.setText(formatedValue);
        this._winAmountLabel.pivot.set(this._winAmountLabel.width / 2, this._winAmountLabel.height / 2);
    }

    #showWinLabel() {
        return new Promise(resolve => {
            this.#setLabelsVisibility(true);
            gsap.fromTo(
                [this._totalWinLabelContainer, this._continueTextContainer, this._freeSpinsTextContainer],
                { alpha: 0 },
                { alpha: 1, duration: 1, onComplete: () => resolve() }
            );
        });
    }

    #startWinLabelIdleTween() {
        this._winLabelIdleTween = gsap
            .fromTo(this._totalWinLabelContainer.scale,
                {
                    x: 1,
                    y: 1
                },
                {
                    x: 1.1,
                    y: 1.1,
                    duration: 1,
                    yoyo: true,
                    repeat: -1
                })
    }

    #hideWinLabel() {
        this.#stopWinLabelIdleAnimation();
        return new Promise(resolve => {
            gsap.fromTo(
                [this._totalWinLabelContainer, this._continueTextContainer, this._freeSpinsTextContainer],
                { alpha: 1 },
                {
                    alpha: 0, duration: 1, onComplete: () => {
                        this.#setLabelsVisibility(false);
                        this._winAmountLabel.setText("");
                        this._totalWinLabelContainer.scale.set(1);
                        resolve();
                    }
                }
            )
        })
    }

    #setLabelsVisibility(visible) {
        const alpha = visible ? 1 : 0;

        this._totalWinLabelContainer.visible = visible;
        this._continueTextContainer.visible = visible;
        this._freeSpinsTextContainer.visible = visible;
        this._totalWinLabelContainer.alpha = alpha;
        this._continueTextContainer.alpha = alpha;
        this._freeSpinsTextContainer.alpha = alpha;
    }

    #stopWinLabelIdleAnimation() {
        if (this._winLabelIdleTween) {
            this._winLabelIdleTween.kill();
            this._winLabelIdleTween = null;
        }
    }
}